export default __webpack_public_path__ + "static/media/ctaDefaultIcon.ce904d02.svg";